<div [class]="theme?.root">
  <div class="flex flex-col m-auto container {{ theme.container }}">
    @if (topContent) {
      <div
        class="wysiwyg py-v-spacing sm:px-v-spacing mb-v-spacing max-w-container mx-auto bundle-builder__top-content"
        [innerHtml]="topContent"
      ></div>
    }
    <div class="bundle-builder__form sm:px-v-spacing">
      @if (isMultiCard) {
        <div class="bg-light text-vis-regular rounded-md shadow-md px-v-spacing py-8 md:p-12 max-w-[776px] mx-auto">
          <!-- ## Component Title ## -->
          @if (formTitle) {
            <div class="wysiwyg bundle-builder__title mb-v-spacing w-full" [innerHTML]="formTitle"></div>
          }
          <p class="text-baselg font-bold mb-2 tab:hidden">{{data.dropDownLabel}}</p>
          <div class="bundle-builder__interactions relative">
            <!-- ## Faux 'Select' button ## -->
            <button #searchToggle class="bundle-builder__search-toggle bg-no-repeat text-vis-dark font-normal text-baselg p-3 h-[52px] border border-visBtn-disabled rounded-md bg-vis-grey-5 w-full cursor-pointer text-left" (click)="toggleBundleSearch()" (keypress.enter)="toggleBundleSearch()">Select state license(s)</button>
            <!-- ## Faux 'Select' options modal ## -->
            @if (showBundleSearch) {
              <div #searchDropdown class="bundle-builder__searchable-select__dropdown pointer-events-auto absolute w-full bg-light -mt-0.5 z-50 max-h-[276px] overflow-y-auto">
                <input type="text" class="bundle-builder__search-input bg-no-repeat text-vis-dark font-normal text-base p-3 mx-v-spacing mt-v-spacing border border-visBtn-disabled rounded-md bg-vis-grey-5 w-full cursor-pointer transition-all duration-200" placeholder="Search" [(ngModel)]="searchTerm" (input)="doFiltering()">
                @for (searchOption of bundleOptions; track searchOption) {
                  <div class="bundle-builder__searchable-select__dropdown-option flex flex-row items-center py-3 px-v-spacing cursor-pointer" [class.bg-vis-alt-1]="searchOption.selected" (click)="initialSelection(searchOption)" (keypress.enter)="initialSelection(searchOption)">
                    <input class="w-[17px] h-[17px] mr-3 cursor-pointer text-visBtn-tertiary" type="checkbox" [id]="'deliveryMethod'+ i" [name]="'deliveryMethod'+ i" [value]="searchOption.entryState" [checked]="searchOption.selected" (change)="initialSelection(searchOption)" (click)="$event.stopPropagation()">
                    <label class="bundle-builder__searchable-select__dropdown-item pt-0.5" for="deliveryMethod">{{searchOption.entryState}}</label></div>
                  }
                </div>
              }
              <div class="bundle-builder__selected-options flex flex-row flex-wrap">
                @for (selectedOption of formSelectedOptions; track selectedOption) {
                  <div class="badge flex justify-center align-middle font-bold rounded-lg text-vis-teal-2 bg-vis-teal-2 bg-opacity-[10%] text-sm py-2 px-3 mr-2 mt-1">
                    {{selectedOption.entryState}}
                    <fa-icon tabindex="1" (click)="initialSelection(selectedOption,false)" (keypress.enter)="initialSelection(selectedOption,false)"
                      class="text fa-1x ml-2 cursor-pointer"
                      [icon]="faTimes"
                      aria-label="Remove selected option"
                    ></fa-icon>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <!-- ## Delivery Method ## -->
        @if (hasMultipleFormats) {
          <div class="max-w-[776px] mx-auto" [class.mt-v-spacing]="isMultiCard">
            <p class="text-baselg font-bold mb-3">{{data.deliveryMethodLabel}}</p>
            <div class="bundle-builder__delivery-radio grid gap-2 items-center justify-start md:flex">
              <input type="radio" class="md:mr-2 h-4 text-visBtn-primary" id="deliveryMethodWebinar-{{builderIndex}}" name="deliveryMethod-{{builderIndex}}" value="webinar-{{builderIndex}}" (change)="setSelectedBundles()" [(ngModel)]="deliveryMethod" [disabled]="showBundleSearch">
              <label class="text-base md:text-baselg md:mr-12" for="deliveryMethodWebinar-{{builderIndex}}">Webinar</label>
              <input class="md:mr-2 h-4 text-visBtn-primary" type="radio" id="deliveryMethodOnline-{{builderIndex}}" name="deliveryMethod-{{builderIndex}}" value="online-{{builderIndex}}" (change)="setSelectedBundles()" [disabled]="showBundleSearch" [(ngModel)]="deliveryMethod">
              <label class="text-base md:text-baselg" for="deliveryMethodOnline-{{builderIndex}}">Online</label></div>
            </div>
          }
          <!-- ## Component Title (single-card layout) ## -->
          @if (!isMultiCard && formTitle) {
            <div class="wysiwyg bundle-builder__title mb-v-spacing max-w-[776px] mx-auto sm:px-v-spacing" [innerHTML]="formTitle"></div>
          }
          <!-- ## Selected Product List ## -->
          @if (!showBundleProductList && !emptyStateMessage && licencesSelected && deliveryMethod.length > 0) {
            <loading-indicator class="block mt-9 mx-auto" label="Loading..."></loading-indicator>
          }
          @if (emptyStateMessage) {
            <div
              class="bundle-builder__empty-state max-w-[776px] mx-auto bg-light text-vis-regular rounded-md shadow-md px-v-spacing py-8 md:p-12 text-center"
              role="status"
              aria-live="polite"
              >
              <p class="text-baselg">{{ emptyStateMessage }}</p>
            </div>
          }
          @if (showBundleProductList) {
            <div class="bundle-builder__class-list max-w-[776px] mx-auto bg-light text-vis-regular rounded-md shadow-md px-v-spacing py-8 md:p-12">
              <div>
                <div class="wysiwyg bundle-builder__core-product-title mb-4 md:mb-8 md:inline-block md:w-1/2" [innerHTML]="productListTitle"></div>
                <div class="flex md:inline-flex md:w-1/2 mb-8 md:mb-4 md:justify-end">
                  <div class="text-vis-regular text-sm px-3 py-2 border border-visBtn-disabled rounded-md bg-vis-muted mr-2">
                    <span class="font-extrabold">Required:</span> {{requiredHours}} Hrs
                  </div>
                  <div class="text-vis-dark text-sm px-3 py-2 border rounded-md bg-opacity-30 {{ hourStatusClasses }}">
                    <span class="font-extrabold">Selected:</span> {{bundleHours}} Hrs
                  </div>
                </div>
                <div class="wysiwyg bundle-builder__core-product-content mb-2" [innerHTML]="recommendedProductContent"></div>
                @if (selectedBaseProduct?.moreInfo) {
                  <div class="wysiwyg bundle-builder__more-info mb-4" [innerHTML]="selectedBaseProduct.moreInfo"></div>
                }
                @if (selectedBaseProduct && selectedBaseProduct !== null) {
                  <bundle-product-card
                    class="block w-full mb-8"
                    [data]="selectedBaseProduct"
                    [showHours]="!isMultiCard"
                    (productSelectionChange)="addToCheckout($event)"
                  ></bundle-product-card>
                }
                @if (requiredClassProductList.length > 0) {
                  <div class="wysiwyg bundle-builder__req-product-title mb-2" [innerHTML]="requirementsTitle"></div>
                }
                @for (product of requiredClassProductList; track product) {
                  <bundle-product-card class="block w-full mb-8" [data]="product" [showHours]="isRequiredSingleCard()" (productSelectionChange)="addToCheckout(product)"></bundle-product-card>
                }
                @if (electiveClasses.length > 0) {
                  <div class="wysiwyg bundle-builder__elective-product-title mb-2" [innerHTML]="electivesTitle"></div>
                }
                @for (product of electiveClasses; track product) {
                  <bundle-product-card class="block w-full mb-8" [data]="product" [showHours]="isElectiveSingleCard()" (productSelectionChange)="addToCheckout(product)"></bundle-product-card>
                }
                <!-- ## Total ## -->
                <div class="bundle-builder__total p-v-spacing rounded-md bg-vis-alt-1 mb-8">
                  <div class="text-base font-extrabold flex flex-row justify-between">
                    <span>Total Tuition:</span>
                    <span>${{totalCostFormatted}}</span>
                  </div>
                  @if (isMultiCard) {
                    <p class="text-sm text-vis-subtle">*Does not include NMLS Credit Reporting Fee</p>
                  }
                </div>
                <!-- ## Faux modal button and modal ## -->
                @if (!hasEnoughHours && checkoutProductIds.length > 0) {
                  <button #modalCTA class="bundle-builder__modal-toggle v-button primary-button w-full" (click)="showModal = !showModal" (keypress.enter)="showModal = !showModal">{{data.cartCtaLabel}}</button>
                }
                @if (showModal) {
                  <div class="fixed inset-0 bg-vis-dark/50 z-50 flex justify-center items-center">
                    <div #modal class="bundle-builder__modal-card w-full max-w-[576px] px-8 py-10 bg-light text-vis-regular shadow-md relative rounded">
                      <h3 class="mb-2">You do not have enough selected hours to meet your state requirement(s).</h3>
                      <p class="text-base">Are you sure you want to proceed to checkout?</p>
                      <div class="grid sm:grid-cols-2 mt-v-spacing gap-3">
                        <button class="v-button primary-button" (click)="showModal = false" (keypress.enter)="showModal = false">Modify Selection</button>
                        <vision-button
                          class="bundle-builder__checkout-cta"
                          defaultStyle="secondary"
                          [data]="modalCheckoutButtonData"
                          (click)="markCheckoutNavigation($event)"
                        ></vision-button>
                      </div>
                    </div>
                  </div>
                }
                <!-- ## Checkout Button ## -->
                @if (hasEnoughHours || checkoutProductIds.length === 0) {
                  <vision-button
                    [disabled]="checkoutProductIds.length === 0"
                    defaultStyle="primary"
                    [data]="checkoutButtonData"
                    (click)="markCheckoutNavigation($event)"
                  ></vision-button>
                }
              </div>
            </div>
          }
